// /* eslint-disable @typescript-eslint/no-unused-vars */
// import { IconCircle, IconCircleCheckFilled, IconX } from "@tabler/icons-react";
// import { useRef, useState } from "react";
// import { useForm } from "react-hook-form";
// import Input from "../../../components/Input";
// import { useOrderLabelPrintMutation } from "../../../apis/orderApis";
// import toast from "react-hot-toast";

// type LabelPrintModalProps = {
//   open: boolean;
//   onClose: () => void;
//   order: any;
// };

// export default function LabelPrintModal({
//   open,
//   onClose,
//   order,
// }: LabelPrintModalProps) {
//   const {
//     register,
//     handleSubmit,
//     setValue,
//     watch,
//     formState: { errors },
//   } = useForm<any>();

//   const [step, setStep] = useState<"generate" | "preview">("generate");
//   const [selectedSystem, setSelectedSystem] = useState<"default" | "3pl">(
//     "default"
//   );
//   const printRef = useRef<HTMLDivElement>(null);
//   const { mutate, isPending } = useOrderLabelPrintMutation(order?.id ?? "");

//   const handleGenerate = (data: any) => {
//     const payload = {
//       ...data,
//       system: selectedSystem, // include selected system in payload
//     };

//     mutate(payload, {
//       onSuccess: (data: any) => {
//         onClose()
//       },
//       onError: (error) => {
//         console.log(error, "error");
//         // toast.error(`${error}`);
//       },
//     });
//     // onClose()
//   };

//   const handlePrint = () => {
//     if (!printRef.current) return;
//     const content = printRef.current.innerHTML;
//     const win = window.open("", "", "width=800,height=600");
//     if (win) {
//       win.document.write(`
//           <html>
//             <head><title>Print</title></head>
//             <body onload="window.print(); window.close();">
//               ${content}
//             </body>
//           </html>
//         `);
//       win.document.close();
//     }
//   };

//   if (!open) return null;

//   return (
//     <div className="fixed top-0 left-0 w-full h-screen bg-black/60 z-50 flex items-center justify-center">
//       <div className="rounded-2xl ">
//         <div className="flex items-center">
//           <div className=" bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] flex items-center justify-between px-6 py-4   w-full rounded-tl-3xl rounded-tr-[63px] ">
//             <h2 className="text-2xl">Label Print</h2>
//           </div>
//           <div className="relative ">
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               width={38}
//               height={37}
//               viewBox="0 0 38 37"
//               fill="none"
//               className="absolute -bottom-[10px] -left-[8px] rotate-[-1.8deg]"
//             >
//               <path
//                 d="M0.5 0L4.86189 10.5496C10.4737 24.1222 22.9306 33.645 37.5 35.5L4.91509 37L0.5 0Z"
//                 fill="#F7F6F2"
//               />
//             </svg>

//             <button
//               onClick={onClose}
//               className="bg-[#F2F2F7] rounded-full p-1 cursor-pointer w-12 h-12 ml-5 flex items-center justify-center flex-shrink-0"
//             >
//               <IconX size={20} />
//             </button>
//           </div>
//         </div>
//         <div className="w-full py-4 px-6 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tr-[30px]">
//           <div className="w-[655px]">
//             {step === "generate" && (
//               <>
//                 {/* Content */}
//                 <div className="">
//                   <p className="text-sm font-medium mb-2">Select System</p>
//                   <div className="grid grid-cols-2 gap-4">
//                     {/* Default Label Print */}
//                     <div
//                       onClick={() => setSelectedSystem("default")}
//                       className={`border rounded-lg p-2 flex items-start space-x-2 cursor-pointer ${
//                         selectedSystem === "default"
//                           ? "bg-[#FBD037]/10 border-[#FBD037]"
//                           : "bg-transparent border-[#D8D8D8]"
//                       }`}
//                     >
//                       <div>
//                         {selectedSystem === "default" ? (
//                           <IconCircleCheckFilled className="text-[#FBD037]" />
//                         ) : (
//                           <IconCircle className="text-black/60" />
//                         )}
//                       </div>
//                       <div>
//                         <p className="text-base font-medium">
//                           Default Label Print
//                         </p>
//                         <p className="text-sm text-[#212121]/80">
//                           Default System AWB
//                         </p>
//                       </div>
//                     </div>

//                     {/* 3PL Label Print */}
//                     <div
//                       onClick={() => setSelectedSystem("3pl")}
//                       className={`border rounded-lg p-2 flex items-start space-x-2 cursor-pointer ${
//                         selectedSystem === "3pl"
//                           ? "bg-[#FBD037]/10 border-[#FBD037]"
//                           : "bg-transparent border-[#D8D8D8]"
//                       }`}
//                     >
//                       <div>
//                         {selectedSystem === "3pl" ? (
//                           <IconCircleCheckFilled className="text-[#FBD037]" />
//                         ) : (
//                           <IconCircle className="text-black/60" />
//                         )}
//                       </div>
//                       <div>
//                         <p className="text-base font-medium">3PL label Print</p>
//                         <p className="text-sm text-[#212121]/80">
//                           Forwarded AWB
//                         </p>
//                       </div>
//                     </div>

//                     <Input
//                       title="Size"
//                       name="size"
//                       value="4 x 6 inches"
//                       className=""
//                       register={register}
//                       disabled
//                     />

//                     <Input
//                       title="No. of Pieces"
//                       name="noOfPieces"
//                       type="number"
//                       placeholder=""
//                       className=""
//                       register={register}
//                       error={errors?.noOfPieces}
//                       validation={{
//                         required: "No. of pieces is required",
//                         min: {
//                           value: 1,
//                           message: "At least 1 piece is required",
//                         },
//                         max: {
//                           value: 9999,
//                           message: "Maximum allowed is 9999 pieces",
//                         },
//                       }}
//                     />
//                   </div>
//                 </div>

//                 {/* Footer */}
//               </>
//             )}
//           </div>
//         </div>

//         <div className="border-t border-[#D8D8D8] px-6 py-4 flex justify-end space-x-2  bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-b-[30px]">
//           <button
//             onClick={handleSubmit(handleGenerate)}
//             className="bg-[#FBD037] hover:bg-yellow-400 text-[#000000] flex items-center rounded-full p-2 px-6 space-x-1 disabled:cursor-not-allowed cursor-pointer text-sm font-medium"
//           >
//             {isPending ? "Generating..." : "Generate"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

/* eslint-disable @typescript-eslint/no-unused-vars */
import { IconX } from "@tabler/icons-react";
import { useRef, useState } from "react";
import { useForm } from "react-hook-form";
import Input from "../../../components/Input";
import { useOrderLabelPrintMutation } from "../../../apis/orderApis";
import toast from "react-hot-toast";
import NewinputField from "../../../components/NewInput";
import { useLanguage } from "../../../context/LanguageContext";

type LabelPrintModalProps = {
  open: boolean;
  onClose: () => void;
  order: any;
  inPlace?: boolean;
};

export default function LabelPrintModal({
  open,
  onClose,
  order,
  inPlace = false,
}: LabelPrintModalProps) {
  const { t } = useLanguage();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<any>({
    defaultValues: {
      noOfPieces: 1,
    },
  });

  const is3PLStatus = order?.status === "FORWARD_TO_3PL";
  const [is3PLEnabled, setIs3PLEnabled] = useState<boolean>(is3PLStatus);

  const selectedSystem = is3PLEnabled ? "3pl" : "default";

  const { mutate, isPending } = useOrderLabelPrintMutation(order?.id ?? "");

  const handleGenerate = (data: any) => {
    const payload = {
      ...data,
      system: selectedSystem,
    };
    mutate(payload, {
      onSuccess: () => {
        toast.success(t("Label generated successfully"));
        onClose();
      },
      onError: (error) => {
        toast.error(error?.message || t("Failed to generate label"));
        console.log(error, "error");
      },
    });
  };

  if (!open) return null;

  if (inPlace) {
    return (
      <div className="bg-white backdrop-blur-md border border-slate-200/80 shadow-sm rounded-2xl overflow-hidden flex flex-col">
        {/* Header */}
        <div className="flex justify-between items-center px-5 py-4 border-b border-slate-100 bg-white">
          <h3 className="text-lg font-bold text-[#212121]">{t("Label Print")}</h3>
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={handleSubmit(handleGenerate)}
              disabled={isPending}
              className="p-1.5 px-4 rounded-lg text-xs font-semibold transition-all duration-200 flex items-center justify-center gap-2 bg-[#FBD037] hover:bg-[#f7c400] text-black shadow hover:shadow-md cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isPending ? t("Generating...") : t("Generate")}
            </button>
            <button
              type="button"
              onClick={onClose}
              className="p-1.5 rounded-lg border border-[#D2D2D2] hover:bg-gray-100 transition-colors text-slate-700"
            >
              <IconX size={16} />
            </button>
          </div>
        </div>

        <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 m-4 transition-all duration-300 space-y-3">
     

          <div className="flex items-center justify-between bg-white border border-[#E8E8E8] rounded-xl px-4 py-2.5 shadow-sm">
            <div>
              <p className="text-xs font-semibold text-[#212121]">
                {is3PLEnabled ? t("3PL Label Print") : t("Default Label Print")}
              </p>
              <p className="text-[10px] text-[#212121]/60">
                {is3PLEnabled
                  ? t("Switch to Default")
                  : t("Switch to 3PL (Forwarded AWB)")}
              </p>
            </div>
            <button
              type="button"
              onClick={() => setIs3PLEnabled((prev) => !prev)}
              className={`relative inline-flex h-5 w-9 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ${
                is3PLEnabled ? "bg-[#FBD037]" : "bg-[#D8D8D8]"
              }`}
              role="switch"
              aria-checked={is3PLEnabled}
            >
              <span
                className={`pointer-events-none inline-block h-4 w-4 transform rounded-full bg-white shadow-md ring-0 transition duration-200 ease-in-out ${
                  is3PLEnabled ? "translate-x-4" : "translate-x-0"
                }`}
              />
            </button>
     <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <NewinputField
              className="flex items-center gap-2"
              title={t("Size")}
              name="size"
              value={t("4 x 6 inches")}
              register={register}
              disabled
            />
            <NewinputField
              className="flex items-center gap-2"
              title={t("Pieces")}
              name="noOfPieces"
              type="number"
              placeholder=""
              register={register}
              error={errors?.noOfPieces}
              validation={{
                required: t("No. of pieces is required"),
                min: { value: 1, message: t("At least 1 piece is required") },
                max: { value: 9999, message: t("Maximum allowed is 9999 pieces") },
              }}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed top-0 left-0 w-full h-screen bg-black/60 z-50 flex items-center justify-end p-4">
      <div className="rounded-2xl w-full max-w-[500px] h-[calc(100vh-2rem)] flex flex-col relative bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] shadow-2xl overflow-hidden animate-in fade-in slide-in-from-right duration-300">
        {/* Header */}
        <div className="flex items-center flex-shrink-0">
          <div className="bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] flex items-center justify-between px-6 py-4 w-full rounded-tl-3xl">
            <h2 className="text-2xl font-bold">{t("Label Print")}</h2>
          </div>
          <div className="relative">
            <button
              onClick={onClose}
              className="bg-[#F2F2F7] rounded-full p-1 cursor-pointer w-12 h-12 mr-4 flex items-center justify-center flex-shrink-0 hover:bg-gray-300 transition"
            >
              <IconX size={20} />
            </button>
          </div>
        </div>

        {/* Body */}
        <div className="w-full flex-1 overflow-y-auto p-6 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] scrollbar-clean">
          <div className="space-y-4">
            {/* Toggle only — no cards */}
            <div className="flex items-center justify-between bg-white border border-[#E8E8E8] rounded-xl px-4 py-2.5 shadow-sm">
              <div>
                <p className="text-sm font-semibold text-[#212121]">
                  {is3PLEnabled ? t("3PL Label Print") : t("Default Label Print")}
                </p>
                <p className="text-xs text-[#212121]/60">
                  {is3PLEnabled
                    ? t("Switch to Default Label Print")
                    : t("Switch to 3PL (Forwarded AWB)")}
                </p>
              </div>
              <button
                type="button"
                onClick={() => setIs3PLEnabled((prev) => !prev)}
                className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none ${
                  is3PLEnabled ? "bg-[#FBD037]" : "bg-[#D8D8D8]"
                }`}
                role="switch"
                aria-checked={is3PLEnabled}
              >
                <span
                  className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-md ring-0 transition duration-200 ease-in-out ${
                    is3PLEnabled ? "translate-x-5" : "translate-x-0"
                  }`}
                />
              </button>
            </div>

            {/* Fields */}
            <div className="bg-white p-4 rounded-xl shadow-md space-y-4">
              <Input
                title={t("Size")}
                name="size"
                value={t("4 x 6 inches")}
                register={register}
                disabled
              />
              <Input
                title={t("No. of Pieces")}
                name="noOfPieces"
                type="number"
                placeholder=""
                register={register}
                error={errors?.noOfPieces}
                validation={{
                  required: t("No. of pieces is required"),
                  min: { value: 1, message: t("At least 1 piece is required") },
                  max: {
                    value: 9999,
                    message: t("Maximum allowed is 9999 pieces"),
                  },
                }}
              />
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="border-t border-[#D8D8D8] px-6 py-4 flex justify-end gap-2 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] flex-shrink-0">
          <button
            onClick={onClose}
            className="w-full sm:w-auto h-11 px-6 rounded-full border border-[#D8D8D8] bg-white hover:bg-[#F5F5F5] transition-all duration-200 font-medium cursor-pointer"
          >
            {t("Cancel")}
          </button>
          <button
            onClick={handleSubmit(handleGenerate)}
            disabled={isPending}
            className="w-full sm:w-auto min-w-[140px] h-11 px-6 rounded-full font-semibold transition-all duration-200 flex items-center justify-center gap-2 bg-[#FBD037] hover:bg-[#f7c400] text-black shadow-lg hover:shadow-xl cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isPending
              ? t("Generating...")
              : `${t("Generate")} ${is3PLEnabled ? t("3PL") : t("Default")} ${t("Label")}`}
          </button>
        </div>
      </div>
    </div>
  );
}
